import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=0a0b9a13&scoped=true"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=0a0b9a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b9a13",
  null
  
)

export default component.exports